import {
  Button,
  Checkbox,
  CloseButton,
  ModalBody,
  ModalHeader,
} from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from "react";
import FTIcon from "react-file-type-icons";
import CadIcon from "../../../Assets/Icons/cad.png";
import { FormDiv, Submit, UploadDiv } from "./attachementStyle";
import { Icons } from "../../../Utils";
import { Tag, Input, Spin, Select, Radio } from "antd";
import { API, axiosInstance } from "../../../Services";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { actionCreators } from "../../../Redux";
import { bindActionCreators } from "redux";
import { useDispatch, useSelector } from "react-redux";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

export default function UploadAttachment(props) {
  // v2 detection — radio + inventory flow only exist when project is v2.
  const isV2 = props?.projectVersion === "v2";

  // FIX: sirf isV2 (projectVersion) kaafi nahi hai — agar us checklist
  // item ka hasRsform null hai to poora "inventory" experience (label,
  // Title Block editor, source/output form) hide hona chahiye aur purana
  // simple single-file form dikhna chahiye, chahe project v2 hi kyun na ho.
  // Ye ek hi combined flag ab har jagah (upar useEffect samet) use hoga,
  // taaki teeno jagah (label / title block / upload-box) consistent rahein.
  const showInventoryUI = isV2 && !!props?.hasRsform;

  // "project"  -> old behaviour (single file list, attachment API)
  // "inventory"-> new behaviour (source/output lists, inventory API)
  // Default is always "project", so v1 behaves exactly like before.
  const [uploadMode, setUploadMode] = useState(
    props?.projectVersion === "v2" ? "inventory" : "project"
  );

  const { Option } = Select;
  const { id } = useParams();
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const {
    trelloCommentList,
    projectAttachementSubCategories,
    trelloAttachmentList,
  } = bindActionCreators(actionCreators, dispatch);

  // ---- shared form state (category / approval / tags / loading) ----
  const [formData, setFormData] = useState({ isNeedAproval: false });
  const [tags, setTags] = useState([]);
  const [loading, setLoad] = useState(false);

  // =========================================================
  // TITLE BLOCK (Quill editor) — same idea/API as TitleBlockTab.jsx,
  // just embedded here above "The File Need Approval?" and sized smaller.
  // Prefilled from the service's `titleBlock` field (from listOrders),
  // matched by serviceID; saved against props.inventoryId on submit.
  // =========================================================
  const [titleBlockValue, setTitleBlockValue] = useState("");
  const [titleBlockLoading, setTitleBlockLoading] = useState(false);
  const isTitleBlockPrefilled = useRef(false);
  // FIX: the prefill fetch below is async (listOrders call). If it
  // resolves AFTER the user has already started typing in the editor,
  // its `.then()` was overwriting whatever the user typed back to the
  // fetched (often empty/null) value — that's why "null" was going even
  // though something was typed. This ref tracks "user has touched the
  // editor" so the late-resolving prefill can skip overwriting it.
  const userEditedTitleBlockRef = useRef(false);

  useEffect(() => {
    // FIX: ab showInventoryUI (isV2 + hasRsform dono) check ho raha hai —
    // pehle sirf isV2 check hota tha, isliye hasRsform null hone par bhi
    // ye fetch chal jaata tha jabki Title Block editor render hi nahi hota.
    if (!showInventoryUI || !props?.serviceID || isTitleBlockPrefilled.current) return;

    setTitleBlockLoading(true);
    axiosInstance
      .get(`/internal/pm/listOrders/${id}`)
      .then((res) => {
        const orders = res.data?.orders || [];
        let matchedService = null;
        for (const order of orders) {
          for (const service of order.services || []) {
            if (service.ID === props.serviceID) {
              matchedService = service;
              break;
            }
          }
          if (matchedService) break;
        }
        // FIX: only apply the fetched prefill if the user hasn't already
        // started typing — otherwise this would wipe out their input.
        if (!userEditedTitleBlockRef.current) {
          // NEW: prefill from service.titleBlock (can be null -> empty editor)
          setTitleBlockValue(matchedService?.titleBlock || "");
        }
        isTitleBlockPrefilled.current = true;
      })
      .catch((err) => {
        console.error("[titleBlock] listOrders fetch failed:", err);
      })
      .finally(() => {
        setTitleBlockLoading(false);
      });
  }, [showInventoryUI, props?.serviceID, id]);

  // User's own edits always win — mark the editor as "touched" the
  // moment they type, so the prefill fetch (if still in flight) won't
  // clobber it when it resolves later.
  const handleTitleBlockChange = (value) => {
    userEditedTitleBlockRef.current = true;
    setTitleBlockValue(value);
  };

  // Same API shape as TitleBlockTabAPI.js's submitTitleBlock — posts
  // title_block as FormData against the inventoryId.
  const submitTitleBlockAPI = (inventoryId, titleBlockContent) => {
    const fd = new FormData();
    fd.append("title_block", titleBlockContent);
    return axiosInstance.post(
      `/rsform/inventories/titleBlock/${inventoryId}`,
      fd,
      {
        headers: {
          "x-api-key": `${localStorage.getItem("token")}`,
        },
      }
    );
  };

  // =========================================================
  // PROJECT MODE state (unchanged from the original component)
  // =========================================================
  const fileInputRef = useRef(null);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [previewUrls, setPreviewUrls] = useState([]);

  // ==========/internal/DaySessions/status===============================================
  // INVENTORY MODE state (source + output dual upload)
  // =========================================================
  const sourceInputRef = useRef(null);
  const outputInputRef = useRef(null);
  const [sourceInputKey, setSourceInputKey] = useState(0);
  const [outputInputKey, setOutputInputKey] = useState(0);
  const [sourceFiles, setSourceFiles] = useState([]);
  const [sourcePreviews, setSourcePreviews] = useState([]);
  const [outputFiles, setOutputFiles] = useState([]);
  const [outputPreviews, setOutputPreviews] = useState([]);
  const [previewImage, setPreviewImage] = useState(null);
  const [draggingItem, setDraggingItem] = useState({
    section: null,
    index: null,
  });
  const [dragOverTarget, setDragOverTarget] = useState({
    section: null,
    index: null,
  });

  // FIX: ab showInventoryUI (upar defined, isV2 + hasRsform dono) reuse
  // ho raha hai — ye "Inventory Upload" label aur Title Block editor ke
  // saath consistent hai, taaki hasRsform null hone par poora old form hi
  // dikhe, sirf upload-box hi na badle.
  const isInventoryMode = showInventoryUI && uploadMode === "inventory";

  useEffect(() => {
    if (state.projectAttachementCategories?.categories?.length > 0) {
      let id;
      if (props.isCheklist == true) {
        id = state.projectAttachementCategories?.categories
          ?.filter((item) => item?.name == "Service Upload")
          .map((i) => i.ID);
      } else {
        id = state.projectAttachementCategories?.categories
          ?.filter((item) => item?.name == "General Upload")
          .map((i) => i.ID);
      }
      projectAttachementSubCategories(id);
    }
  }, []);

  /* =========================================================
   *  PROJECT MODE handlers (original logic, untouched)
   * ========================================================= */
  const handleFileSelect = (event) => {
    let files = event.target.files;
    setSelectedFiles([...selectedFiles, ...files]);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    let files = event.dataTransfer.files;
    setSelectedFiles([...selectedFiles, ...files]);
  };

  const handleRemoveFile = (index) => {
    let newSelectedFiles = [...selectedFiles];
    newSelectedFiles.splice(index, 1);
    setSelectedFiles(newSelectedFiles);

    let newPreviewUrls = [...previewUrls];
    newPreviewUrls.splice(index, 1);
    setPreviewUrls(newPreviewUrls);
  };

  useEffect(() => {
    Promise.all(
      selectedFiles.map((file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            resolve(reader.result);
          };
          reader.readAsDataURL(file);
        });
      })
    ).then((results) => {
      setPreviewUrls(results);
    });
  }, [selectedFiles]);

  const renderSelectedFiles = () => {
    return selectedFiles.map((file, index) => {
      return (
        <div key={index} className="preview-div">
          <button onClick={() => handleRemoveFile(index)}>X</button>
          {previewUrls[index] && (
            <div className="display-preview">
              {file.type.startsWith("image/") ? (
                <img
                  className="preview"
                  src={previewUrls[index]}
                  alt="Preview"
                />
              ) : (
                <div className="filename">
                  {file.name?.split(".").pop() !== ("cad" || "CAD") ? (
                    <span className="file-icon">
                      <FTIcon
                        fileName={file.name?.split(".")?.pop() || "url"}
                        style={{ fontSize: "40px" }}
                        color="#2b6b2a"
                        fileType={"url"}
                      />
                    </span>
                  ) : (
                    <img src={CadIcon} style={{ width: "40px" }} alt="" />
                  )}
                </div>
              )}
            </div>
          )}
          <span className="file-name">{file.name}</span>
        </div>
      );
    });
  };

  /* =========================================================
   *  INVENTORY MODE handlers (source / output dual upload)
   * ========================================================= */
  const getFiles = (section) =>
    section === "source" ? sourceFiles : outputFiles;
  const getPreviews = (section) =>
    section === "source" ? sourcePreviews : outputPreviews;
  const setFilesFor = (section, updater) =>
    section === "source" ? setSourceFiles(updater) : setOutputFiles(updater);
  const setPreviewsFor = (section, updater) =>
    section === "source"
      ? setSourcePreviews(updater)
      : setOutputPreviews(updater);

  const handleInvFileSelect = (section) => (event) => {
    const filesArray = Array.from(event.target.files || []);
    if (filesArray.length === 0) return;

    setFilesFor(section, (prev) => [...prev, ...filesArray]);

    if (section === "source") {
      setSourceInputKey((k) => k + 1);
    } else {
      setOutputInputKey((k) => k + 1);
    }
  };

  const handleInvDrop = (section) => (event) => {
    event.preventDefault();
    // reorder drops are handled by the thumbnail itself
    if (draggingItem.section !== null) return;
    const files = Array.from(event.dataTransfer.files || []);
    if (files.length > 0) {
      setFilesFor(section, (prev) => [...prev, ...files]);
    }
  };

  const handleInvRemoveFile = (section, index) => {
    setFilesFor(section, (prev) => prev.filter((_, i) => i !== index));
    setPreviewsFor(section, (prev) => prev.filter((_, i) => i !== index));
  };

  const reorderFiles = (section, fromIndex, toIndex) => {
    const currentFiles = getFiles(section);
    const currentPreviews = getPreviews(section);
    if (
      fromIndex === toIndex ||
      fromIndex == null ||
      toIndex < 0 ||
      toIndex >= currentFiles.length
    ) {
      return;
    }

    const newFiles = [...currentFiles];
    const newPreviews = [...currentPreviews];

    const [movedFile] = newFiles.splice(fromIndex, 1);
    const [movedPreview] = newPreviews.splice(fromIndex, 1);

    newFiles.splice(toIndex, 0, movedFile);
    newPreviews.splice(toIndex, 0, movedPreview);

    setFilesFor(section, () => newFiles);
    setPreviewsFor(section, () => newPreviews);
  };

  useEffect(() => {
    Promise.all(
      sourceFiles.map(
        (file) =>
          new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(file);
          })
      )
    ).then((results) => setSourcePreviews(results));
  }, [sourceFiles]);

  useEffect(() => {
    Promise.all(
      outputFiles.map(
        (file) =>
          new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(file);
          })
      )
    ).then((results) => setOutputPreviews(results));
  }, [outputFiles]);

  const clearDragState = () => {
    setDraggingItem({ section: null, index: null });
    setDragOverTarget({ section: null, index: null });
  };

  const renderFileCard = (section, file, index) => {
    const previews = getPreviews(section);
    const isDragging =
      draggingItem.section === section && draggingItem.index === index;
    const isDropTarget =
      dragOverTarget.section === section &&
      dragOverTarget.index === index &&
      !isDragging;

    return (
      <div
        key={`${section}-${index}`}
        draggable
        onDragStart={(e) => {
          e.dataTransfer.effectAllowed = "move";
          setDraggingItem({ section, index });
        }}
        onDragEnd={clearDragState}
        onDragEnter={(e) => {
          e.preventDefault();
          if (draggingItem.section === section) {
            setDragOverTarget({ section, index });
          }
        }}
        onDragOver={(e) => e.preventDefault()}
        onDrop={(e) => {
          e.preventDefault();
          e.stopPropagation();
          if (draggingItem.section === section) {
            reorderFiles(section, draggingItem.index, index);
          }
          clearDragState();
        }}
        title="Drag to reorder"
        style={{
          position: "relative",
          boxSizing: "border-box",
          width: "92px",
          flex: "0 0 auto",
          padding: "4px",
          background: "#fff",
          border: isDropTarget ? "2px dashed #1890ff" : "1px solid #ececec",
          borderRadius: "6px",
          opacity: isDragging ? 0.35 : 1,
          cursor: "grab",
          transition: "border 0.15s ease, opacity 0.15s ease",
        }}
      >
        <button
          onClick={() => handleInvRemoveFile(section, index)}
          style={{
            position: "absolute",
            top: "3px",
            right: "3px",
            zIndex: 2,
            border: "none",
            background: "rgba(0,0,0,0.6)",
            color: "#fff",
            borderRadius: "50%",
            width: "16px",
            height: "16px",
            fontSize: "10px",
            lineHeight: "16px",
            padding: 0,
            cursor: "pointer",
          }}
        >
          X
        </button>

        <div
          style={{
            position: "absolute",
            top: "3px",
            left: "3px",
            zIndex: 2,
            minWidth: "16px",
            height: "16px",
            padding: "0 4px",
            borderRadius: "8px",
            background: "#2d3a4b",
            color: "#fff",
            fontSize: "10px",
            fontWeight: 600,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {index + 1}
        </div>

        <div
          style={{
            width: "100%",
            height: "70px",
            marginTop: "2px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
            borderRadius: "4px",
            background: "#fafafa",
          }}
        >
          {previews[index] &&
            (file.type.startsWith("image/") ? (
              <img
                src={previews[index]}
                alt="Preview"
                onClick={(e) => {
                  e.stopPropagation();
                  setPreviewImage(previews[index]);
                }}
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "cover",
                  cursor: "zoom-in",
                }}
              />
            ) : (
              <div className="filename">
                {file.name?.split(".").pop() !== ("cad" || "CAD") ? (
                  <span className="file-icon">
                    <FTIcon
                      fileName={file.name?.split(".")?.pop() || "url"}
                      style={{ fontSize: "34px" }}
                      color="#2b6b2a"
                      fileType={"url"}
                    />
                  </span>
                ) : (
                  <img src={CadIcon} style={{ width: "34px" }} alt="" />
                )}
              </div>
            ))}
        </div>

        <div
          style={{
            fontSize: "10px",
            marginTop: "4px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
          title={file.name}
        >
          {file.name}
        </div>
      </div>
    );
  };

  const renderUploadBox = (section) => {
    const files = getFiles(section);
    const inputRef = section === "source" ? sourceInputRef : outputInputRef;
    const inputKey = section === "source" ? sourceInputKey : outputInputKey;
    const label = section === "source" ? "Upload Source" : "Upload Output";
    const buttonLabel =
      section === "source" ? "Choose Source File" : "Choose Output File";

    return (
      <div style={{ marginBottom: "1.25rem" }}>
        <div
          className="ap-fsm ap-fwmd"
          style={{ marginBottom: "6px", fontSize: "14px", fontWeight: 600 }}
        >
          {label} <span style={{ color: "red" }}>*</span>
        </div>

        <div
          className="file-upload"
          onDragOver={(event) => event.preventDefault()}
          onDrop={handleInvDrop(section)}
          style={{
            border: "1px dashed #d9d9d9",
            borderRadius: "6px",
            padding: "12px",
          }}
        >
          {files.length > 0 ? (
            <>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "10px",
                  maxHeight: "230px",
                  overflowY: "auto",
                  paddingRight: "2px",
                }}
              >
                {files.map((file, index) =>
                  renderFileCard(section, file, index)
                )}
              </div>
              <div style={{ marginTop: "10px" }}>
                <Button size="sm" onClick={() => inputRef.current.click()}>
                  + Add more
                </Button>
                <input
                  key={`${section}-input-${inputKey}`}
                  ref={inputRef}
                  type="file"
                  multiple
                  onChange={handleInvFileSelect(section)}
                  style={{ display: "none" }}
                />
              </div>
            </>
          ) : (
            <div className="placeholder" style={{ textAlign: "center" }}>
              <div>
                <Button onClick={() => inputRef.current.click()}>
                  {buttonLabel}
                </Button>
                <input
                  key={`${section}-input-empty-${inputKey}`}
                  ref={inputRef}
                  type="file"
                  multiple
                  onChange={handleInvFileSelect(section)}
                  style={{ display: "none" }}
                />
              </div>
              <div> or</div> <div>Drag it here...</div>
            </div>
          )}
        </div>
      </div>
    );
  };

  /* =========================================================
   *  SUBMIT
   * ========================================================= */

  // ---- PROJECT / v1 submit (unchanged: attachment API) ----
  const onSubmitProject = () => {
    setLoad(true);
    let uploadData = new FormData();

    for (let i = 0; i < selectedFiles.length; i++) {
      uploadData.append("media[]", selectedFiles[i]);
    }
    uploadData.append(
      "approverGroupID",
      formData?.isNeedAproval ? formData?.groupID : "123 "
    );
    uploadData.append("tags", tags.join(","));
    uploadData.append("category", formData?.category);

    if (props.isCheklist == true) {
      uploadData.append("orderID", props?.orderID);
      uploadData.append("serviceID", props?.serviceID);
      uploadData.append("isFileNeedApproval", 1);
      uploadData.append(
        "inventory_id",
        props?.projectVersion === "v2" ? props?.inventoryId || null : null
      );
    } else {
      uploadData.append("isFileNeedApproval", 0);
    }

    API.addTrelloAttachment(id, uploadData)
      .then((res) => {
        setLoad(false);
        toast.success("updated successfully.", { position: "top-right" });
        trelloAttachmentList(id, `limit=5&page=1`);
        trelloCommentList(id, 20, 1);
        props?.onUploadSuccess?.();
        props.onClose();
      })
      .catch((err) => {
        setLoad(false);
        toast.error("Error", err.message, { position: "top-right" });
        props.onClose();
      });
  };

  /* =========================================================
   *  INVENTORY API
   *  POST /internal/pm/addAttachmentInventory/{projectId}
   *  entity = "inventory", folder = "source" | "output"
   *  axiosInstance use karta hai — same auth as rest of project (x-api-key)
   * ========================================================= */
  const addAttachmentInventory = (projectId, uploadData) =>
    axiosInstance.post(
      `/internal/pm/addAttachmentInventory/${projectId}`,
      uploadData
    );

  const buildInventoryFormData = (folder, files) => {
    const uploadData = new FormData();

    uploadData.append("entity", "inventory");
    uploadData.append("folder", folder);

    files.forEach((file) => {
      uploadData.append("media[]", file);
    });

    uploadData.append(
      "approverGroupID",
      formData?.isNeedAproval ? formData?.groupID : "123 "
    );
    uploadData.append("category", formData?.category);

    if (props.isCheklist == true) {
      uploadData.append("orderID", props?.orderID);
      uploadData.append("serviceID", props?.serviceID);
      uploadData.append("isFileNeedApproval", 1);
      uploadData.append("inventory_id", props?.inventoryId || null);
    } else {
      uploadData.append("isFileNeedApproval", 0);
    }

    return uploadData;
  };

  // UPDATED ORDER: title block API ab SABSE PEHLE chalti hai, uske baad
  // source, phir output (agar dono/ek me files hon). Loading state (setLoad)
  // in sab ke poora hone tak (ya kisi ek me error aane tak) true hi rehta
  // hai. Agar sirf source ya sirf output hi bheja gaya ho, to bas wahi ek
  // call chalegi — doosri skip ho jaayegi.
  const onSubmitInventory = async () => {
    setLoad(true);

    try {
      // 1) Title block — runs first now.
      if (props?.inventoryId) {
        await submitTitleBlockAPI(props.inventoryId, titleBlockValue);
      }

      // 2) Source
      if (sourceFiles.length > 0) {
        await addAttachmentInventory(
          id,
          buildInventoryFormData("source", sourceFiles)
        );
      }

      // 3) Output
      if (outputFiles.length > 0) {
        await addAttachmentInventory(
          id,
          buildInventoryFormData("output", outputFiles)
        );
      }

      setLoad(false);
      toast.success("updated successfully.", { position: "top-right" });
      trelloAttachmentList(id, `limit=5&page=1`);
      trelloCommentList(id, 20, 1);
      props?.onUploadSuccess?.();
      props.onClose();
    } catch (err) {
      setLoad(false);
      toast.error("Error: " + err.message, { position: "top-right" });
      props.onClose();
    }
  };

  const onSubmit = () => {
    if (isInventoryMode) {
      onSubmitInventory();
    } else {
      onSubmitProject();
    }
  };

  // Title Block only renders when isCheklist + showInventoryUI (see JSX
  // below), so it's only required in that case. ReactQuill returns
  // "<p><br></p>" (not "") when the editor is empty/cleared, so strip
  // tags before checking for real text.
  const isTitleBlockEmpty = () => {
    const plainText = (titleBlockValue || "")
      .replace(/<(.|\n)*?>/g, "")
      .trim();
    return plainText.length === 0;
  };

  const isSubmitDisabled = () => {
    const titleBlockMissing =
      props.isCheklist == true && showInventoryUI && isTitleBlockEmpty();

    if (isInventoryMode) {
      return (
        loading ||
        (sourceFiles.length === 0 && outputFiles.length === 0) ||
        !formData?.category ||
        titleBlockMissing
      );
    }
    return (
      loading ||
      selectedFiles.length === 0 ||
      !formData?.category ||
      titleBlockMissing
    );
  };

  return (
    <div>
      <ModalHeader style={{ justifyContent: "space-between", display: "flex" }}>
        Upload File{" "}
        <div>
          <CloseButton
            onClick={() => {
              props.onClose();
            }}
          />
        </div>
      </ModalHeader>
      <ModalBody>
        <UploadDiv>
          {/* FIX: pehle sirf isV2 check hota tha, ab showInventoryUI
          (isV2 + hasRsform) — taaki hasRsform null hone par ye label bhi
          hide ho jaaye aur poora purana form dikhe */}
          {showInventoryUI && (
            <div style={{ marginBottom: "1rem" }}>
              <strong>Inventory Upload</strong>
            </div>
          )}

          {isInventoryMode ? (
            /* ---------- INVENTORY MODE: source + output ---------- */
            <>
              {renderUploadBox("source")}
              {renderUploadBox("output")}
            </>
          ) : (
            /* ---------- PROJECT / v1 MODE: single list ---------- */
            <div
              className="file-upload"
              onDragOver={(event) => event.preventDefault()}
              onDrop={handleDrop}
            >
              {selectedFiles.length > 0 ? (
                <>
                  {renderSelectedFiles()}
                  <div>
                    <Button
                      onClick={() => {
                        fileInputRef.current.click();
                      }}
                    >
                      +
                    </Button>
                    <input
                      ref={fileInputRef}
                      type="file"
                      multiple
                      onChange={handleFileSelect}
                      style={{ display: "none" }}
                    />
                  </div>
                </>
              ) : (
                <div className="placeholder">
                  <div>
                    <Button
                      onClick={() => {
                        fileInputRef.current.click();
                      }}
                    >
                      Choose a file
                    </Button>
                    <input
                      ref={fileInputRef}
                      type="file"
                      multiple
                      onChange={handleFileSelect}
                      style={{ display: "none" }}
                    />
                  </div>
                  <div> or</div> <div>Drag it here...</div>
                </div>
              )}
            </div>
          )}

          <FormDiv>
            {props.isCheklist == true && (
              <>
                {/* Title Block editor — same idea/API as TitleBlockTab.jsx,
                    just smaller and placed right above the approval
                    checkbox. FIX: ab isV2 ki jagah showInventoryUI
                    (isV2 + hasRsform) check ho raha hai, taaki hasRsform
                    null hone par ye editor bhi hide ho aur purana plain
                    form dikhe (jaisa screenshot me hai). */}
                {showInventoryUI && (
                  <div style={{ marginBottom: "1.5rem" }}>
                    <div
                      className="ap-fsm ap-fwmd"
                      style={{ marginBottom: "4px" }}
                    >
                      Title Block <span style={{ color: "red" }}>*</span>
                    </div>
                    {titleBlockLoading ? (
                      <div style={{ padding: "8px 0" }}>
                        <Spin size="small" /> Loading title block...
                      </div>
                    ) : (
                      <div style={{ paddingBottom: "28px" }}>
                        <ReactQuill
                          value={titleBlockValue}
                          onChange={handleTitleBlockChange}
                          theme="snow"
                          style={{ height: "110px" }}
                        />
                      </div>
                    )}
                  </div>
                )}

                <Checkbox
                  size="lg"
                  colorScheme="green"
                  isChecked={true}
                  mr={2}
                  mb={2}
                  mt={4}
                  onChange={(e) => {
                    setFormData((prev) => {
                      prev = JSON.parse(JSON.stringify(prev));
                      prev[`isNeedAproval`] = e?.target?.checked;
                      return prev;
                    });
                  }}
                >
                  The File Need Approval?
                </Checkbox>
                <br />
              </>
            )}

            <div style={{ padding: "1rem 0" }}>
              <div className="ap-flex ap-flex-center-center ap-w100">
                <Select
                  size="large"
                  showSearch
                  value={formData?.category}
                  labelInValue
                  placeholder="Select Category"
                  style={{ width: "100%" }}
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  onChange={(data) => {
                    setFormData((prev) => {
                      prev = JSON.parse(JSON.stringify(prev));
                      prev[`category`] = data.value;
                      return prev;
                    });
                  }}
                >
                  {" "}
                  {state.projectAttachementSubCategories?.subCategories?.map(
                    (cat, adminIndex) => (
                      <Option value={cat.ID} key={adminIndex}>
                        {cat.name}
                      </Option>
                    )
                  )}
                </Select>
              </div>
            </div>
          </FormDiv>
          <Submit>
            <Button
              className="submit_right1"
              isDisabled={isSubmitDisabled()}
              onClick={onSubmit}
              isLoading={loading ? <Spin /> : false}
            >
              Submit
            </Button>
          </Submit>
        </UploadDiv>
      </ModalBody>

      {/* Full-size image preview / "zoom" (inventory thumbnails) */}
      {previewImage && (
        <div
          onClick={() => setPreviewImage(null)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.8)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2000,
            cursor: "zoom-out",
          }}
        >
          <img
            src={previewImage}
            alt="Full preview"
            onClick={(e) => e.stopPropagation()}
            style={{
              maxWidth: "90%",
              maxHeight: "90%",
              borderRadius: "6px",
              boxShadow: "0 4px 24px rgba(0,0,0,0.5)",
              cursor: "default",
            }}
          />
          <button
            onClick={(e) => {
              e.stopPropagation();
              setPreviewImage(null);
            }}
            style={{
              position: "absolute",
              top: "20px",
              right: "24px",
              background: "rgba(255,255,255,0.15)",
              border: "none",
              color: "#fff",
              width: "36px",
              height: "36px",
              borderRadius: "50%",
              fontSize: "18px",
              cursor: "pointer",
            }}
          >
            ×
          </button>
        </div>
      )}
    </div>
  );
}